var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouseClosedWorkingHours({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_833_879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.875C5.51289 1.875 1.875 5.51289 1.875 10C1.875 14.4801 5.52031 18.125 10 18.125C14.4867 18.125 18.125 14.4867 18.125 10C18.125 5.51992 14.4801 1.875 10 1.875ZM14.2188 11.25H9.53125C9.48981 11.25 9.45007 11.2335 9.42076 11.2042C9.39146 11.1749 9.375 11.1352 9.375 11.0938V4.53125C9.375 4.48981 9.39146 4.45007 9.42076 4.42076C9.45007 4.39146 9.48981 4.375 9.53125 4.375H10.4688C10.5102 4.375 10.5499 4.39146 10.5792 4.42076C10.6085 4.45007 10.625 4.48981 10.625 4.53125V10H14.2188C14.2602 10 14.2999 10.0165 14.3292 10.0458C14.3585 10.0751 14.375 10.1148 14.375 10.1562V11.0938C14.375 11.1352 14.3585 11.1749 14.3292 11.2042C14.2999 11.2335 14.2602 11.25 14.2188 11.25Z",
    fill: "#14AC63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5L4.67842 -0.00611408L5.84713 1.38669L1.6687 4.89281L0.5 3.5Z",
    fill: "#14AC63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1797,
    y: 4.89893,
    width: 5.45455,
    height: 1.81818,
    transform: "rotate(-140 18.1797 4.89893)",
    fill: "#14AC63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_833_879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseClosedWorkingHours);
export default __webpack_public_path__ + "static/media/WarehouseClosedWorkingHours.eee9169c268882a20f2bc9625a7ad2ac.svg";
export { ForwardRef as ReactComponent };